import React from 'react'

function PlaceholderIcon() {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='73'
            height='73'
            fill='none'
            viewBox='0 0 73 73'>
            <path
                stroke='#2E2D2C'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2.441'
                d='M54.01 42.46c16-16 17.23-40.72 17.23-40.72S46.52 2.97 30.52 18.97c-6.88 6.88-11.02 15.36-13.51 22.81L31.2 55.97c7.45-2.49 15.93-6.63 22.81-13.51zM16.94 41.71l14.27 14.27M16.94 41.71l14.27 14.27'></path>
            <path
                stroke='#2E2D2C'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2.315'
                d='M13.14 46.09l13.79 13.79M16.94 41.71L1.9 34.89C11.91 24.88 21.77 18.9 28.48 21.02M31.21 55.98l6.82 15.04C48.04 61.01 54.02 51.15 51.9 44.44M53.05 5.59l14.27 14.27M49.7 31.6c-2.29 2.29-6.01 2.29-8.31 0-2.29-2.29-2.29-6.01 0-8.31 2.29-2.29 6.01-2.29 8.31 0 2.29 2.29 2.29 6.01 0 8.31zM11.1 52.22l-9.7 9.7M20.8 61.92l-9.7 9.7M15.93 57.05l-5.88 5.88'></path>
        </svg>
    )
}

export default PlaceholderIcon
